import { useState } from "react";
import WorkspaceShell from "@/components/WorkspaceShell";
import StudentPicker from "@/components/StudentPicker";
import StudentWorkspace from "@/components/StudentWorkspace";
import ExamRanking from "@/components/ExamRanking";
import ExamCalendar from "@/features/ExamCalendar";
import ProgramTemplates from "@/features/ProgramTemplates";
import { Users, Medal, CalendarDays, LayoutTemplate } from "lucide-react";

export default function CoachPanel() {
  const [selected, setSelected] = useState(null);
  return (
    <WorkspaceShell
      subtitle="Eğitim Koçu"
      mainNav={[
        { id: "students", label: "Öğrencilerim", icon: Users },
        { id: "templates", label: "Program Şablonları", icon: LayoutTemplate },
        { id: "examrank", label: "Deneme Başarı Tablosu", icon: Medal },
        { id: "exams", label: "Sınav Takvimi", icon: CalendarDays },
      ]}
    >
      {(tab, main) =>
        main === "templates" ? (
          <ProgramTemplates />
        ) : main === "examrank" ? (
          <ExamRanking />
        ) : main === "exams" ? (
          <ExamCalendar />
        ) : (
          <>
            <div className="mb-5">
              <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">Öğrencilerim</h1>
              <p className="text-slate-500 text-sm mt-1">Bir öğrenci seç, programını ve tüm takip verilerini düzenle.</p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-5">
              <StudentPicker selected={selected} onSelect={setSelected} />
              <div>
                {selected ? (
                  <StudentWorkspace studentId={selected.id} studentName={selected.name} track={selected.track} readOnly={false} tab={tab} />
                ) : (
                  <div className="card-ta p-12 text-center text-slate-500">
                    Verilerini görüntülemek için soldan bir öğrenci seçin.
                  </div>
                )}
              </div>
            </div>
          </>
        )
      }
    </WorkspaceShell>
  );
}
